import { defineInternalTask } from '../../../config/types';
import { internalTasks, reviewTeams } from '../../../config/constants';

import { baseBindState, formatAddress, getPrimarySegment, normalizeAddress } from './lib/helpers';

export const primaryResidenceVerification = defineInternalTask({
  taskName: internalTasks.PrimaryResidenceVerification,
  config: {
    staffDisplayName: 'Not primary residence: verification needed',
    reviewTeam: reviewTeams.uwOps,
    policyTypes: ['H', 'C'],
    enabled: true,
    // Post-bind read from `policy.segments[0]` (the same node legacy ticket.repository.js
    // uses — see line 73: `policyDetails = policy.segments[0]`). At bind time the
    // mailing address flows bindDetails → offer.quote.global.mailingAddress → policy.
    trigger: ({ policy }) => {
      const segment = getPrimarySegment(policy);
      const correctedAddress = segment?.correctedAddress;
      const mailingAddress = segment?.global?.mailingAddress;
      if (!correctedAddress || !mailingAddress) {
        return null;
      }
      // Compare full address (street + city + state + zip) so two different
      // properties that share a street name don't compare equal.
      const homeAddr = normalizeAddress(correctedAddress);
      const mailAddr = normalizeAddress(mailingAddress);
      if (!homeAddr || !mailAddr || homeAddr === mailAddr) {
        return null;
      }
      return {
        data: {
          homeAddress: formatAddress(correctedAddress),
          mailingAddress: formatAddress(mailingAddress)
        },
        bindState: baseBindState(policy)
      };
    },
    description: ({ policyId, data }) =>
      `${policyId} has a different mailing address than the insured property address.
If the property is a secondary property, please take appropriate underwriting action.
Mailing Address: ${data.mailingAddress || 'N/A'}
Home Location: ${data.homeAddress || 'N/A'}`
  }
});
